module.exports = __webpack_public_path__ + "img/malbec-granReserva.5b683744.jpg";